import React from "react";
import { Button, Grid } from "@mui/material";
import CaseAnalysisTimeseries from "src/scenes/case-analysis/case-analysis-timeseries";
import styled from "styled-components";
import NoDataPlaceholder from "src/components/no-data-placeholder";

const DescriptionText = styled.p`
    margin: 0;
    padding: 12px;
    font-size: 12px;
    font-weight: 200;
    border-radius: 12px;
    background-color: #2b2b2b;
    // text-align: left;
`;

const CaseAnalysisGraphSection = ({ areChartsVisible, setAreChartsVisible, data }) => {
    if (!data || data.length === 0) return null;
    if (data && data.error !== null) return null;
    if (data && data.graph && data.graph.error !== null)
        return <NoDataPlaceholder variant="correlation" errorMessage={data.graph.error} />;
    return (
        <>
            <Grid item mt={4} mb={8} md={12}>
                {areChartsVisible ? (
                    <Button
                        variant="contained"
                        onClick={() => setAreChartsVisible(!areChartsVisible)}
                    >
                        Hide correlation over time chart
                    </Button>
                ) : (
                    <Button
                        variant="contained"
                        onClick={() => setAreChartsVisible(!areChartsVisible)}
                    >
                        Show correlation over time chart
                    </Button>
                )}
            </Grid>
            {areChartsVisible &&
                (data && data.graph && data.graph.error === null ? (
                    <Grid
                        item
                        style={{
                            width: "100%",
                            height: "300px",
                            textAlign: "center",
                            marginBottom: "30%",
                        }}
                    >
                        <DescriptionText style={{ whiteSpace: "pre-line" }}>
                            {data.graph.explanation}
                        </DescriptionText>
                        <CaseAnalysisTimeseries data={data.graph.data} />
                        <DescriptionText
                            style={{
                                marginTop: "14px",
                                whiteSpace: "pre-line",
                            }}
                        >
                            {data.graph.description}
                        </DescriptionText>
                    </Grid>
                ) : (
                    <NoDataPlaceholder variant="correlation" errorMessage={data.graph.error} />
                ))}
        </>
    );
};

export default CaseAnalysisGraphSection;
